export default "__VITE_ASSET__118e1c1e__"